module.exports = __webpack_public_path__ + "static/img/title918.c16d190.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awardTW/img/title918.png
// module id = YgeF
// module chunks = 1